


import { ArrowUpward, Delete, Edit, FilterList, Instagram, YouTube } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import SearchIcon from '@mui/icons-material/Search'; // Import the MUI search icon
import { Slider } from '@mui/material'; // Import Slider component from MUI
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'; // Import Skeleton styles
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import List from './List';
import ManagerHeader from './ManagerHeader';
import Navbar from './Navbar';
import axios from "axios";
const  ManagerHome= () => {
  const [data, setData] = useState([]);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchName, setSearchName] = useState('');
  const [searchCategory, setSearchCategory] = useState('');
  const [searchLocation, setSearchLocation] = useState('');
  const [searchState, setSearchState] = useState('');
  const [searchCity, setSearchCity] = useState('');
  const [searchFollowersRange, setSearchFollowersRange] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingMore, setLoadingMore] = useState(false);
  const [searchCostingRange, setSearchCostingRange] = useState([0, 100000]);
  const [managerName, setManagerName] = useState('');
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // State to track the current page
  const itemsPerPage = 20; // Number of items to display per page
     const [showPremiumModal, setShowPremiumModal] = useState(false);
  
  const navigate = useNavigate();






  
  const fetchManagerData = async () => {
    try {
      const managerID = localStorage.getItem('managerID');
      const token = localStorage.getItem("mangertoken");

      if (!token) {
        navigate("/ManagerLogin");
        return;
      }
      if (!managerID) {
        console.error("Manager ID not found in localStorage.");
        return;
      }

      const res = await axios.get(`https://server-side-influencer.onrender.com/manager/managers/${managerID}`);
      console.log("Manager Data Header Response:", res);

      if (res.data && res.data.success === true && res.data.data.name) {
        setManagerName(res.data.data.name);
      
      }
    } catch (err) {
      console.error('Error fetching manager data:', err);
    }
  };

  const loadMoreData = () => {
    setLoadingMore(true); // Start loading
    setTimeout(() => {
      setCurrentPage((prevPage) => prevPage + 1); // Increment page number to load more data
      setLoadingMore(false); // Stop loading after 3 seconds
    }, 3000); // 3 seconds delay for loading
  };

  useEffect(() => {
    // Check if token exists
    const token = localStorage.getItem("mangertoken");

    if (!token) {
      // If no token found, redirect to login page
      navigate("/ManagerLogin");
      return; // Exit early if no token
    }

    // You can add more logic here if you need to handle the case where a token is found
  }, [navigate]); // Make sure to add 'navigate' as a
  // Followers Range options
  const followersRangeOptions = [
    { label: '0 - 1000', min: 0, max: 1000 },
    { label: '1000 - 5000', min: 1000, max: 5000 },
    { label: '5000 - 10000', min: 5000, max: 10000 },
    { label: '10000 - 50000', min: 10000, max: 50000 },
    { label: '50000 - 100000', min: 50000, max: 100000 },
    { label: '100000 - 500000', min: 100000, max: 500000 },
    { label: '500000 - 1000000', min: 500000, max: 1000000 },
    { label: '1000000 - 5000000', min: 1000000, max: 5000000 },
  ];

  // Fetch API data
  const fetchData = async () => {
    try {
      const response = await fetch('https://server-side-influencer.onrender.com/manager/allcsvinfluencers');
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      const result = await response.json();
      setData(result); // Store the fetched data
      const uniqueCategories = [...new Set(result.map(item => item.category))]; // Extract unique categories
      const uniqueStates = [...new Set(result.map(item => item.state))]; // Extract unique states
      const uniqueCities = [...new Set(result.map(item => item.city))]; // Extract unique cities
      setCategories(uniqueCategories); // Set unique categories
      setStates(uniqueStates); // Set unique states
      setCities(uniqueCities); // Set unique cities
    } catch (err) {
      setError(err.message); // Set error state
    } finally {
      setLoading(false); // Stop loading
    }
  };



  const handleSearchChange = (e) => {
    setSearchName(e.target.value);
    setLoading(true); // Start loading when user starts typing

    // Simulate delay for the loading (adjust as needed)
    setTimeout(() => {
      setLoading(false); // Stop loading after filtering is done
    }, 500); // Adjust delay as per your filtering logic
  };


  const handleSearchLocation = (e) => {
    setSearchLocation(e.target.value);
    setLoading(true); // Start loading when user starts typing

    // Simulate delay for the loading (adjust as needed)
    setTimeout(() => {
      setLoading(false); // Stop loading after filtering is done
      // You can filter the data based on the searchLocation here.
    }, 10000); // Adjust delay as per your filtering logic
  };
  const handleUpload = async (event) => {
    event.preventDefault();
  
    if (!file) {
      toast.error("Please select a CSV file to upload.");
      return;
    }
  
    const formData = new FormData();
    formData.append("file", file);
  
    try {
      const response = await fetch("https://server-side-influencer.onrender.com/manager/managercsv", {
        method: "POST",
        body: formData,
      });
  
      const result = await response.json();
  
      if (response.ok) {
        toast.success("File uploaded successfully!");
        fetchData(); // Refresh data after successful upload
      } else {
        toast.error(`Upload Failed: ${result.message || "Something went wrong."}`);
      }
    } catch (error) {
      toast.error("Network error: Unable to connect to server.");
    }
  };

  const handleExportCSV = () => {
    if (selectedRows.length === 0) {
      Swal.fire({
        title: "Error",
        text: "Please select at least one row to export.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return; // Stop further execution if no rows are selected
    }
    const selectedRowsData = selectedRows.map((index) => filteredData[index]);
    exportCSV(selectedRowsData);
  };
  
  const exportCSV = (selectedRowsData) => {
    // All required headers
    const headers = [
      'Name',
      'Instagram Profile',
      'Followers',
      'YouTube Link',
      'Subscribers',
      'Category',
      'Contact Number',
      'Location',
      'State',
      'City',
      'Costing Per Segment',
      'Notes',
      'Hashtags',
      'Managed By',
      'Lifestyle',
      'Email',
    ];
  
    const csvRows = [];
    
    // Add the header row to the CSV
    csvRows.push(headers.join(','));
    
    // Add rows for selected data
    selectedRowsData.forEach(row => {
      const rowData = [
        row.name,
        row.instagramProfile,
        row.followers,
        row.youtubeLink,
        row.subscribers,
        row.category,
        row.contactNumber,
        row.location,
        row.state || 'No State',
        row.city || 'No City',
        row.costingPerSegment,
        row.notes || 'No Notes',  // If no notes, use 'No Notes'
        row.hashtags || 'No Hashtags',  // If no hashtags, use 'No Hashtags'
        row.managedBy || 'No Manager',  // If no manager, use 'No Manager'
        row.lifestyle || 'No Lifestyle',  // If no lifestyle, use 'No Lifestyle'
        row.email || 'No Email',  // If no email, use 'No Email'
      ];
      
      // Push the row data to the CSV
      csvRows.push(rowData.join(','));
    });
  
    // Create a Blob with the CSV data
    const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  
    // Create a link to trigger the download
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'selected_influencers.csv';  // CSV file name
    link.click();  // Trigger the download
  };
  
  

  const handleResetFilters = () => {
    setSearchName('');
    setSearchCategory('');
    setSearchLocation('');
    setSearchState('');
    setSearchCity('');
    setSearchFollowersRange('');
    setSearchCostingRange([0, 100000]);
  };


  useEffect(() => {
    fetchData(); // Fetch data when the component mounts
  }, []);

  const filteredData = data.filter(
    (row) =>
      row.name.toLowerCase().includes(searchName.toLowerCase()) &&
      row.category.toLowerCase().includes(searchCategory.toLowerCase()) &&
      row.location.toLowerCase().includes(searchLocation.toLowerCase()) &&
      row.state.toLowerCase().includes(searchState.toLowerCase()) &&
      row.city.toLowerCase().includes(searchCity.toLowerCase()) &&
      (searchFollowersRange
        ? row.followers >= followersRangeOptions[searchFollowersRange].min &&
          row.followers <= followersRangeOptions[searchFollowersRange].max
        : true) &&
      (row.costingPerSegment >= searchCostingRange[0] && row.costingPerSegment <= searchCostingRange[1]) // Filter based on costing range
  );


  const displayedData = filteredData.slice(0, currentPage * itemsPerPage);
  // Handler for costing range change
  const handleCostingRangeChange = (event, newValue) => {
    setSearchCostingRange(newValue);
  };
  

  const handleUpArrow = (row) => {
    // Log the entire row data (or use it as needed)
    console.log("Up arrow clicked for row:", row);
    console.log("Name:", row.name);
    console.log("Location:", row.location);
    console.log("Followers:", row.followers);
    navigate('/allinfluencer1', { state: { influencer: row } });
    // Add more logs or logic as necessary for the other fields
  };
  
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };
  

  const handleDelete = async (_id) => {
    console.log("Item ID to delete:", _id);
  
    try {
      const response = await fetch(`https://server-side-influencer.onrender.com/manager/deletecsv/${_id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (response.ok) {
        toast.success('Deleted successfully!', {
          position: toast.POSITION.TOP_RIGHT,
        });
        fetchData(); // After successful deletion, fetch the updated data
      } else {
        const errorData = await response.json();
        toast.error(`Failed to delete item: ${errorData.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.error('Error occurred:', error);
      toast.error('An error occurred while deleting the item.', {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  const handleRowSelect = (index) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(index)
        ? prevSelected.filter((id) => id !== index)
        : [...prevSelected, index]
    );
  };

  const handleSelectAll = () => {
    if (selectedRows.length === data.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(data.map((_, index) => index)); // Select all rows
    }
  };

  const handleLinkClick = (link) => {
    window.open(link, '_blank');
  };

  const handleEdit = (item) => {
    navigate('/edit', { state: { item } });
  };

  useEffect(() => {
    
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 760);
    };

    handleResize(); // Check initial sizesssssas
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  const handleAddItem = async (_id) => {
    try {
      const managerId = localStorage.getItem('managerID');
      if (!managerId) {
        toast.error('Brand ID not found in localStorage', {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
  
      const response = await fetch(`https://server-side-influencer.onrender.com/manager/influencer/add/${managerId}/${_id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (response.ok) {
        toast.success('Added successfully!', {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        const errorData = await response.json();
        toast.error(`${errorData.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.error('Error occurred:', error);
      toast.error('Something went wrong!', {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  useEffect(() => {

    fetchManagerData();
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 720);
    };

    handleResize(); // Check initial size
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  return (

    
<div className="flex h-screen mb-0 bg-white page-scroll">
    <div className="text-white fixed top-0 left-0 bottom-0 z-10">
      <Navbar />
    </div>

    {/* <div className="flex h-screen">
      <Navbar />  */}
      <div className="ml-[0%] flex-1 overflow-y-auto p-4 mb-0">
        <ManagerHeader  page="ManagerHome" />


{/* 
<h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-extrabold text-center text-black mt-[50px] mb-[50px] cursor-pointer hover:text-gray-700 transition-all duration-300 ease-in-out transform hover:scale-105 ml-[10px] break-words">
  Start Searching Influencers from a Large Database
  <span className="block text-base sm:text-sm md:text-base lg:text-lg font-normal text-gray-600 mt-0 ml-[10px] break-words">
    Discover top influencers to elevate your brand's reach and impact.
  </span>
</h1> sss*/}


<div className="text-right text-sm sm:text-base md:text-lg lg:text-2xl font-semibold mr-8 mt-10  sm:mt-0 text-gray-700 "   style={{ marginTop: '60px' }}>
                👏 Welcome back,{managerName}
              </div>
<h1 
  className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-extrabold text-center text-black mt-[50px] mb-[50px] cursor-pointer hover:text-gray-700 transition-all duration-300 ease-in-out transform hover:scale-105"
  style={{ marginLeft: isSmallScreen? '30px' : '70px' }}
>
  Start Searching Influencers 
  <span className="block text-base sm:text-sm md:text-base lg:text-lg font-normal text-gray-600 mt-0 ml-[20px] sm:ml-0 break-words">
    Discover top influencers to elevate your brand's reach and impact.
  </span>
</h1>




{/* CSV Upload Section */}
{/* <div className="mt-3 flex flex-col items-center justify-center ml-12" style={{ marginBottom: '28px' }}>
          <h2 className="text-lg font-semibold mb-2">Upload CSV File</h2>
          <form onSubmit={handleUpload} className="flex flex-col items-center">
            <input
              type="file"
              accept=".csv"
              onChange={handleFileChange}
              className="mb-4 p-2 border border-gray-300 rounded-lg"
            />
            <button
              type="submit"
              className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
            >
              Upload CSV
            </button>
          </form>
        </div> */}







        <div className="flex justify-center items-center">
  <div className="mb-4 w-full max-w-3xl"> {/* Increased max width ssssssssssss*/}
    <div className="relative mt-2">
      <input
        type="text"
        value={searchName}
        onChange={(e) => setSearchName(e.target.value)}
        onChange={handleSearchChange}
        className="block w-full p-2.5 pl-10 bg-[#F2F4F8] border border-gray-300 text-gray-900 rounded-lg"
        placeholder="Search influencers by names or  keyword"
      />
      {/* MUI Search Icon inside the input field */}
      <SearchIcon
        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
        fontSize="small"
      />
    </div>
  </div>
</div>




<div className="relative mt-[-10%] mb-0">
  <div className="absolute top-0 right-0 mt-[10%] flex items-center space-x-4">
    {/* BrandList component */}
    < List />

    {/* Button */}
   <button
     onClick={() => setDrawerOpen(true)}
     className="text-sm px-4 py-2 mb-2 text-gray-900 border border-gray-400 bg-gray-100 hover:bg-gray-200 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg focus:outline-none dark:bg-gray-600 dark:hover:bg-gray-700 dark:border-gray-500 dark:focus:ring-gray-800 whitespace-nowrap sm:text-base sm:px-5 sm:py-2.5 ml-13"
     style={{ marginLeft: '60px' }}
     type="button"
   >
     <FilterList className="mr-2" />
     Filters
   
     
   
   </button>
  </div>
</div>

        <div className="flex justify-center mt-[-5%] mb-0">
          <div className="text-center mt-[10%] ml-[60%] mb-5">
            {/* <button
              onClick={() => setDrawerOpen(true)}
              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              type="button"
            >
              Show Search Filters
            </button> */}
          </div>

          {/* Drawer component */}
          {drawerOpen && (
            <div className="fixed top-0 left-0 z-40 h-screen p-4 overflow-y-auto transition-transform bg-white w-80 dark:bg-gray-800">
              <h5 className="text-gray-500 dark:text-gray-400 text-lg font-semibold mb-6">Search Filters</h5>


              <button
  onClick={handleResetFilters}
  className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
>
  Reset filters
</button>

              <button
                type="button"
                onClick={() => setDrawerOpen(false)}
                className="absolute top-2.5 right-2.5 text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8"
              >
                <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                </svg>
              </button>

             
              <div className="mb-4">
                <label className="text-sm font-medium text-gray-900 dark:text-white">Name</label>
                <input
                  type="text"
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                  onChange={handleSearchChange}
                  className="block w-full mt-2 p-2.5 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg"
                  placeholder="Search by name"
                />
              </div>


              <div className="mb-4">
                <label className="text-sm font-medium text-gray-900 dark:text-white">Category</label>
                <select
                  value={searchCategory}
                  
                  onChange={(e) => setSearchCategory(e.target.value)}

                  className="block w-full mt-2 p-2.5 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg"
                >
                  <option value="">Select Category</option>
                  {categories.map((category, index) => (
                    <option key={index} value={category}>{category}</option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label className="text-sm font-medium text-gray-900 dark:text-white">Location</label>
                <input
  type="text"
  value={searchLocation}
  onChange={handleSearchLocation}  // Only this one
  className="block w-full mt-2 p-2.5 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg"
  placeholder="Search by location"
/>

              </div>

              {/* New State Dropdown */}
              <div className="mb-4">
                <label className="text-sm font-medium text-gray-900 dark:text-white">State</label>
                <select
                  value={searchState}
                  onChange={(e) => setSearchState(e.target.value)}
                  className="block w-full mt-2 p-2.5 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg"
                >
                  <option value="">Select State</option>
                  {states.map((state, index) => (
                    <option key={index} value={state}>{state}</option>
                  ))}
                </select>
              </div>

              {/* New City Dropdown */}
              <div className="mb-4">
                <label className="text-sm font-medium text-gray-900 dark:text-white">City</label>
                <select
                  value={searchCity}
                  onChange={(e) => setSearchCity(e.target.value)}
                  className="block w-full mt-2 p-2.5 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg"
                >
                  <option value="">Select City</option>
                  {cities.map((city, index) => (
                    <option key={index} value={city}>{city}</option>
                  ))}
                </select>
              </div>




              <div className="mb-4">
                <label className="text-sm font-medium text-gray-900 dark:text-white">Costing Per Segment</label>
                <Slider
                  value={searchCostingRange}
                  onChange={handleCostingRangeChange}
                  valueLabelDisplay="auto"
                  valueLabelFormat={(value) => `₹${value}`}
                  min={0}
                  max={100000}
                  step={1000}
                  className="mt-2"
                />
              </div>
              {/* Followers Range Dropdown */}
              <div className="mb-4">
                <label className="text-sm font-medium text-gray-900 dark:text-white">Followers Range</label>
                <select
                  value={searchFollowersRange}
                  onChange={(e) => setSearchFollowersRange(e.target.value)}
                  className="block w-full mt-2 p-2.5 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg"
                >
                  <option value="">Select Followers Range</option>
                  {followersRangeOptions.map((option, index) => (
                    <option key={index} value={index}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </div>

        {/* Table for displaying filtered influencer data s*/}

{/* 
        <div className="mt-[-16%]">
        <CsvUploader  fetchData={fetchData}  /> 
</div> */}

        {/* <div className="relative overflow-x-auto shadow-md sm:rounded-lg max-h-[calc(100vh-250px)] mt-[10%] mb-0"> */}

        <p className="text-black-600 mb-0 " style={{ marginLeft: isSmallScreen?'10px':'70px' , marginTop:  isSmallScreen?'50px':'50px' }}>
  Showing {filteredData.length} results
</p>

        <div className="relative overflow-x-auto shadow-md sm:rounded-lg max-h-[calc(100vh-250px)] mt-[6%] mb-0 ml-[0px] sm:ml-0">



{/* <div className="sticky top-0 z-10 bg-transparent">
    <button
      onClick={() => setDrawerOpen(true)}
      className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 mb-4 flex items-center space-x-2 ml-[30px]"
      type="button"
    >
      <FilterList fontSize="small" />
      <span className="text-sm">Filters</span>
    </button>
  </div>
           */}
<table 
  className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  style={{
    marginLeft: isSmallScreen? '0px' : '80px', 
 
  }}
>


      <thead className="text-xs text-black uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
        <tr>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">
            <input
              type="checkbox"
              checked={selectedRows.length === filteredData.length}
              onChange={handleSelectAll}
            />
          </th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Name</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Instagram Profile</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Followers</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">YouTube Link</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Subscribers</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Category</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Contact Number</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Location</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">State</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">City</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Costing Per Segment</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Notes</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Hashtags</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Managed By</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Lifestyle</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Email</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Commercial</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">Actions</th>
          <th scope="col" className="px-6 py-3 whitespace-nowrap">More</th>
        </tr>
      </thead>

      <tbody>
        {loading ? (
          // Show Skeleton Loader if loading is true
          [...Array(10)].map((_, index) => (
            <tr key={index}>
              <td colSpan="17" className="text-center py-4 text-gray-500">
                <Skeleton count={2} height={60} />
              </td>
            </tr>
          ))
        ) : filteredData.length === 0 ? (
          <tr>
            <td colSpan="17" className="text-center py-4 text-gray-500 text-3xl">
              No search result found
            </td>
          </tr>
        ) : (
          displayedData.map((row, index) => (
            <tr
              key={index}
              className={`bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 ${selectedRows.includes(index) ? 'bg-blue-100 dark:bg-blue-600' : ''}`}
            >
              <td className="px-6 py-4">
                <input
                  type="checkbox"
                  checked={selectedRows.includes(index)}
                  onChange={() => handleRowSelect(index)}
                />
              </td>
              <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{row.name}</td>
              <td className="px-6 py-4">
                <Instagram
                  onClick={() => handleLinkClick(row.instagramProfile)}
                  className="cursor-pointer text-blue-600 hover:text-blue-800"
                />
              </td>
              <td className="px-6 py-4">{row.followers}</td>
              <td className="px-6 py-4">
                <YouTube
                  onClick={() => handleLinkClick(row.youtubeLink)}
                  className="cursor-pointer text-red-600 hover:text-red-800"
                />
              </td>
              <td className="px-6 py-4">{row.subscribers}</td>
              <td className="px-6 py-4">{row.category}</td>
              <td className="px-6 py-4">
  <div
  onClick={() => setShowPremiumModal(true)}
    className="blur-sm cursor-pointer text-blue-500 hover:underline"
    title="Click to view"
  >

   
    {row.contactNumber}
  </div>
</td>
              <td className="px-6 py-4">{row.location}</td>
              <td className="px-6 py-4">{row.state || 'No State'}</td>
              <td className="px-6 py-4">{row.city || 'No City'}</td>
              <td className="px-6 py-4">₹{row.costingPerSegment}</td>
              <td className="px-6 py-4">{row.notes}</td>
              <td className="px-6 py-4">{row.hashtags}</td>
              <td className="px-6 py-4">{row.managedBy}</td>
              <td className="px-6 py-4">{row.lifestyle}</td>
              <td className="px-6 py-4">
  <div
  onClick={() => setShowPremiumModal(true)}
    className="blur-sm cursor-pointer text-blue-500 hover:underline"
    title="Click to view"
  >
    {row.email}
  </div>
</td>
              <td className="px-6 py-4">{row.commercial}</td>
              <td className="px-6 py-4">
                <div className="flex space-x-2">
                <button
                      onClick={() => handleAddItem(row._id)}
                      className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 whitespace-nowrap"
                    >
                      Add to list
                    </button>
                  <Edit
                    onClick={() => handleEdit(row)}
                    className="cursor-pointer text-blue-600 hover:text-blue-800"
                  />
                  <Delete
                    onClick={() => handleDelete(row._id)}
                    className="cursor-pointer text-red-600 hover:text-red-800"
                  />
                </div>
              </td>

              <td>
                <ArrowUpward
                  onClick={() => handleUpArrow(row)} // Pass the entire row to the function
                  className="cursor-pointer text-gray-600 hover:text-gray-800"
                  style={{ marginLeft: '30px' }} // Apply left margin of 30px
                />
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>



    


{filteredData.length > 0 && filteredData.length > 20 && (
  <div className="text-center mt-4">
    {!loadingMore ? (
      <button
        onClick={loadMoreData}
        className="bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 ml-8 text-white"
      >
        Load More
      </button>
    ) : (
      <div style={{ marginTop: '10px', fontSize: '16px', color: '#555' }}>
        Loading...
      </div>
    )}
  </div>
)}





        </div>


        <div className="mt-4 text-right">
          <button
            onClick={handleExportCSV}
            className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
          >
            Export Selected Rows as CSV
          </button>
        </div>





        {showPremiumModal && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full text-center">
      <h2 className="text-xl font-semibold mb-4">Premium Access Required</h2>
      <p className="mb-6"> only available for premium users.</p>
      <button
        onClick={() => setShowPremiumModal(false)}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        Close
      </button>
    </div>
  </div>
)}







      </div>


      <ToastContainer
        position="bottom-center"  // Toast messages appear at the bottom-center
        autoClose={3000}          // Closes after 3 seconds
        hideProgressBar={false}    // Show progress bar
        closeOnClick
        pauseOnHover
        draggable
      />
    </div>
  );
};

export default  ManagerHome;















